import { createAction } from '@reduxjs/toolkit';

import { SET_USER } from '@/types/store/actions';
import { type User } from '@/types/store/reducers';

// import useAnalytics from '@/hooks/useAnalytics';

export const setUser = createAction<User, typeof SET_USER>(SET_USER);
